import { map } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Notification } from '../_models/notification';
import { environment } from '../../../environments/environment';
import { AppState } from '../_reducers';
import { selectAllNotifications } from '../_selectors/notification.selectors';

@Injectable()
export class NotificationService {
  private apiBaseUrl = environment.apiBaseUrl;
  private notificationList$: Observable<Notification[]>;

  constructor(
    private http: HttpClient,
    private store: Store<AppState>
  ) {
    this.notificationList$ = this.store.pipe(select(selectAllNotifications));
  }

  getFromLocalStore(): Observable<Notification[]> {
    return this.notificationList$;
  }

  getNotifications(): Observable<Notification[]> {
    return this.http
      .get<Notification[]>(this.apiBaseUrl + 'api/private/v1/alerts/notifications?onlySent=true')
      .pipe(map((response) => response));
  }

  getNotificationsByField(fieldId: number): Observable<Notification[]> {
    return this.http
      .get<
        Notification[]
      >(this.apiBaseUrl + 'api/private/v1/alerts/notifications/views/fields/' + fieldId)
      .pipe(map((response) => response));
  }

  getNotification(id: number): Observable<Notification> {
    return this.http
      .get<Notification>(this.apiBaseUrl + 'api/private/v1/alerts/notifications/' + id)
      .pipe(map((response) => response));
  }

  saveNotification(notificationItem): Observable<Notification> {
    const notification = { ...notificationItem };

    delete notification.lastUpdated;
    delete notification.dateCreated;

    if (notification.id) {
      let urlRead = '';
      if (notification.read) {
        urlRead = '/read';
      } else {
        urlRead = '/unread';
      }
      return this.http
        .post<Notification>(
          this.apiBaseUrl + 'api/private/v1/alerts/notifications/' + notification.id + urlRead,
          notification
        )
        .pipe(
          // .map(response => response)
          map((response) => {
            if (response) {
              return response;
            } else {
              return;
            }
          })
        );
    }
  }

  deleteNotification(id: number): Observable<Notification> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/notifications/' + id).pipe(
      map((response) => {
        return { id } as Notification;
      })
    );
  }
}
